import { render, staticRenderFns } from "./ListFarmlands.vue?vue&type=template&id=42c6ab64&scoped=true"
import script from "./ListFarmlands.vue?vue&type=script&lang=js"
export * from "./ListFarmlands.vue?vue&type=script&lang=js"
import style0 from "./ListFarmlands.vue?vue&type=style&index=0&id=42c6ab64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6ab64",
  null
  
)

export default component.exports